import React from 'react';
import { Card, Row, Col, Typography, Divider, Statistic, List, Avatar, Space } from 'antd';
import { BookOutlined, TeamOutlined, DatabaseOutlined } from '@ant-design/icons';
import './Academics.less';

const { Title, Paragraph, Text } = Typography;

const Academics: React.FC = () => {
  // 统计数据
  const statistics = [
    {
      title: '学院数量',
      value: 8,
      prefix: <TeamOutlined />,
      color: '#3f8600',
    },
    {
      title: '专业设置',
      value: 32,
      prefix: <BookOutlined />,
      color: '#cf1322',
    },
    {
      title: '科研项目',
      value: 156,
      prefix: <DatabaseOutlined />,
      color: '#1890ff',
    },
    {
      title: '获奖成果',
      value: 48,
      prefix: <BookOutlined />,
      color: '#fa8c16',
    },
  ];

  // 主要功能模块
  const modules = [
    {
      title: '学院设置',
      icon: <TeamOutlined />,
      description: '包含8个学院，涵盖人文、理工、经管等多个学科领域，为学生提供多样化的专业选择。',
      link: '/academics/departments',
    },
    {
      title: '专业设置',
      icon: <BookOutlined />,
      description: '设有32个本科专业，涵盖了当前社会发展的主要领域，注重培养学生的实践能力和创新思维。',
      link: '/academics/majors',
    },
    {
      title: '科研平台',
      icon: <DatabaseOutlined />,
      description: '拥有多个省级和校级重点实验室，承担了多项国家级和省部级科研项目，科研成果丰硕。',
      link: '/academics/research',
    },
  ];

  // 最新动态
  const news = [
    {
      title: '我校approved3项国家自然科学基金项目',
      date: '2023-09-15',
      description: '近日，国家自然科学基金委员会公布了2023年度国家自然科学基金项目评审结果，我校共有3个项目approved。',
    },
    {
      title: '新增2个本科专业通过教育部备案',
      date: '2023-08-28',
      description: '教育部说明了2022年度普通高等学校本科专业备案和审批结果，我校申报的人工智能和数据科学与大数据技术2个专业成功通过备案。',
    },
    {
      title: '2023年省级教学成果奖评选结果揭晓',
      date: '2023-07-12',
      description: '我校共有5项成果获得省级教学成果奖，其中一等奖2项，二等奖3项，获奖数量和质量均创历史新高。',
    },
  ];

  return (
    <div className="academics-container">
      <Title level={2} className="page-title">教学科研</Title>
      <Paragraph className="page-description">
        羊小羊大学始终坚持以教学为中心，以科研为动力，致力于培养具有创新精神和实践能力的高素质人才。
        学校拥有完善的学科体系和一流的师资队伍，在教学和科研方面取得了显著成就。
      </Paragraph>

      {/* 统计数据卡片 */}
      <div className="statistics-section">
        <Row gutter={[16, 16]}>
          {statistics.map((stat, index) => (
            <Col xs={24} sm={12} md={6} key={index}>
              <Card>
                <Statistic
                  title={stat.title}
                  value={stat.value}
                  prefix={stat.prefix}
                  valueStyle={{ color: stat.color }}
                />
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      <Divider />

      {/* 主要功能模块 */}
      <div className="modules-section">
          <Title level={3} className="section-title">
            教学科研模块
          </Title>
        <Row gutter={[16, 16]}>
          {modules.map((module, index) => (
            <Col xs={24} md={8} key={index}>
              <Card
                hoverable
                className="module-card"
                cover={<div className="module-icon-container">{module.icon}</div>}
                bodyStyle={{ textAlign: 'center' }}
                onClick={() => window.location.href = module.link}
              >
                <Title level={4}>{module.title}</Title>
                <Paragraph>{module.description}</Paragraph>
                <Text type="secondary" className="view-details">查看详情 &gt;</Text>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      <Divider />

      {/* 最新动态 */}
      <div className="news-section">
          <Title level={3} className="section-title">
            教学科研动态
          </Title>
        <Card>
          <List
            itemLayout="vertical"
            dataSource={news}
            renderItem={(item) => (
              <List.Item>
                <div className="news-item">
                  <div className="news-header">
                    <Space>
                      <Text type="secondary">{item.date}</Text>
                      <Divider type="vertical" />
                      <Avatar size="small" icon={<BookOutlined />} />
                    </Space>
                    <Title level={5}>{item.title}</Title>
                  </div>
                  <Paragraph className="news-content">{item.description}</Paragraph>
                </div>
              </List.Item>
            )}
          />
        </Card>
      </div>

      {/* 教学特色 */}
        <div className="features-section">
            <Title level={3} className="section-title">
              教学特色
            </Title>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Card className="feature-card">
              <Title level={4}>创新人才培养模式</Title>
              <Paragraph>
                学校采用"理论+实践+创新"的人才培养模式，注重学生实践能力和创新思维的培养。
                通过校企合作、产学研结合等方式，为学生提供广阔的实践平台和创新空间。
              </Paragraph>
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card className="feature-card">
              <Title level={4}>一流师资队伍建设</Title>
              <Paragraph>
                学校拥有一支由院士、长江学者、国家杰出青年基金获得者等高层次人才组成的师资队伍。
                教师队伍结构合理，教学水平高，科研能力强，为学校的教学科研工作提供了强有力的支撑。
              </Paragraph>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Academics;